export default __webpack_public_path__ + "static/media/avatar-9.2893dff2.png";